export default {
    functions: []
};
